import { makeStyles } from '@mui/styles';

const useSelectWithQueryStyle = makeStyles(() => ({
  loaderWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
  },
}));

export default useSelectWithQueryStyle;
